import '../../../core/components/app-root/AppRoot.css';
import './DetailsLayout.css';
export var content = '_1377n3n2-3-12-1';
export var drawer = '_1377n3n3-3-12-1';
export var drawerContent = '_1377n3n4-3-12-1';
export var layoutRoot = '_1377n3n0-3-12-1';
export var panel = '_1377n3n1-3-12-1';